import { Button } from "@/components/ui/button";
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@/components/ui/popover";
import { EvaluationCriteria } from "@/requests/questionnaries/responses-by-quiz-id.request";
import { PopoverClose } from "@radix-ui/react-popover";
import { Information } from "iconsax-react";
import { X } from "lucide-react";
import { FC } from "react";

type EvaluationCriteriaPopoverProps = {
  evaluationCriteria: EvaluationCriteria[];
};

const EvaluationCriteriaPopover: FC<EvaluationCriteriaPopoverProps> = ({
  evaluationCriteria,
}) => {
  return (
    <Popover>
      <PopoverTrigger asChild>
        <Button
          variant={"ghost"}
          size={"sm"}
          className="-ml-2 flex cursor-pointer items-center gap-1 text-xs font-bold text-[#615CB7] underline hover:no-underline"
        >
          <Information size={12} />
          <span className="">Revisar criterios de evaluación</span>
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-full max-w-md">
        <div className="mb-6 flex items-center border-b pb-2 text-lg font-bold text-[#4F5D6D]">
          <span className="grow">Criterios de Evaluación</span>
          <PopoverClose className="ml-auto" asChild>
            <Button variant={"ghost"} size={"icon"} className="ml-auto">
              <X size={16} />
            </Button>
          </PopoverClose>
        </div>

        <ul className="mb-4 flex list-disc flex-col gap-2 pl-6 text-sm text-[#293038]">
          {evaluationCriteria.map((item, index) => (
            <li key={index} className="">
              <strong>{item.criteriaType.name}:</strong>{" "}
              {item.criteriaType.description}
            </li>
          ))}
        </ul>
      </PopoverContent>
    </Popover>
  );
};

export default EvaluationCriteriaPopover;
